import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-static-header-loader',
  templateUrl: './static-header-loader.component.html',
  styleUrls: ['./static-header-loader.component.scss']
})
export class StaticHeaderLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
